import { FormProvider } from "react-hook-form";
import React, { useState, useEffect, useCallback } from "react";
import { Button } from "react-bootstrap";
import "../form.css";
import { DropdownComponent } from "../dropdown";
import "../../../common styling";
import {
  MAX_TRADABLE_INSTRUMENT_TYPE,  
  DURATION_IMMEDIATE, DURATION_DAY, SELL_SIDE, BUY_SIDE,
  ORDERS_FORM, ADD_TRADING_ACCOUNT, ADD_INSTRUMENT,
  INSTRUMENT_SELECTED,
  BUYORDERBOOK_TABLE,
  SELLORDERBOOK_TABLE,
  INSTRUMENTS_TABLE,
  CLEAR_TABLE_DATA,
  DROPDOWN_LIST_NONE,
  MARKET,
  LIMIT,
  DAY,
  FOK,
  HIDDEN,
  DROPDOWN_LIST_NONE_ID,
  typeOptions,
  sessionOptions,
  specialTypeOptions,
  durationTypeOptions,
  triggerConditionOptions,
  SESSION_TYPE_NOT_SET,
  triggerDurationTypeOptions,
} from '../../../common/common';
import { TABLE_ROW_BACKGROUND_COLOR } from "../../../common styling";
import { useOrderForm } from './order_form_logic';
import { DispatchTableEvent } from "../../events/events";

export const OrderForm = () => {

  const {
    code, setCode, codeOptions, setCodeOptions,
    tradingAccount, setTradingAccount,
    price_field, setPriceField, qty_field, setQtyField,
    visible_qty_field, setVisibleQtyField,
    orderType, setOrderType, 
    setFOK,
    setHidden, 
    durationType, setDurationType,
    triggerDurationType, setTriggerDurationType,
    triggerCondition, setTriggerCondition,
    triggerPrice, setTriggerPrice,
    session, setSession,
    specialType, setSpecialType,
    setBuySell, onSubmit, tradingAccountOptions, setTradingAccountOptions,
    handleSubmit, price_step, qty_step,
    triggerOrder, setTriggerOrder,
    scheduleOrder, setScheduleOrder,
  } = useOrderForm();

  // define dropdown lists
  const codeDropDownList = { codeOptions, selectedValue: '', default: 'Select Code', labelName: 'Code' };
  const tradingAccountDropDownList = {tradingAccountOptions, selectedValue: '', default: 'Select Account', labelName: 'Account' };


  // for control states
  const [isPriceDisabled, setIsPriceDisabled] = useState(false);
  const [isSpecialTypeDisabled, setIsSpecialTypeDisabled] = useState(false);
  // const [isTriggerPriceDisabled, setIsTriggerPriceDisabled] = useState(false);
  // const [isVisibleQtyDisabled, setIsVisibleQtyDisabled] = useState(true);
  // const [isSessionDisabled, setIsSessionDisabled] = useState(true);
  // use later when implment session orders
  // const onSessionDropDownChange = useCallback((e) => {setSession(e.target.value)}, [setSession]);
  const [isDurationDisabled, setIsDurationDisabled] = useState(false); 

  const sessionDropDownList = { 
    options: sessionOptions,  
    selectedValue: SESSION_TYPE_NOT_SET,  
    default: 'Select Session', 
    labelName: 'Session' 
  };

  const typeDropDownList = { 
    options: typeOptions,  
    selectedValue: LIMIT,  
    default: LIMIT, 
    labelName: 'Type' 
  };

  const specialTypeDropDownList = { 
    options: specialTypeOptions,  
    selectedValue: triggerCondition,  
    default: DROPDOWN_LIST_NONE, 
    labelName: 'Hidden/FOK' 
  };

  const durationTypeDropDownList = { 
    options: durationTypeOptions,  
    selectedValue: DAY,  
    default: 'Select Duration', 
    labelName: 'Duration' 
  };

  const triggerDurationTypeDropDownList = { 
    options: triggerDurationTypeOptions,  
    selectedValue: DAY,  
    default: 'Select Duration', 
    labelName: 'Duration' 
  };

  const triggerConditionDropDownList = { 
    options: triggerConditionOptions,  
    selectedValue: DROPDOWN_LIST_NONE,  
    default: 'Select Directon', 
    labelName: 'Trigger Cond' 
  };

  const  onCodeDropDownListChange = (event) => {
    setCode(event.target.value);
    setVisibleQtyField('');
    setPriceField('');
    setQtyField('');
    DispatchTableEvent(INSTRUMENT_SELECTED, BUYORDERBOOK_TABLE, event.target.value);
    DispatchTableEvent(INSTRUMENT_SELECTED, SELLORDERBOOK_TABLE, event.target.value);
    DispatchTableEvent(INSTRUMENT_SELECTED, INSTRUMENTS_TABLE, event.target.value);
};

  const AddTradingAccountDropDownItem = useCallback((data) => {
    const newItem = {
      id: data.code,
      name: data.code,
    };

    setTradingAccountOptions(tradingAccountOptions => [...tradingAccountOptions, newItem ]);
  }, [setTradingAccountOptions]);

  const AddInstrumentDropDownItem = useCallback((data) =>{
    //console.log('AddInstrumentDropDownItem, name: ' + addEvent + ', message: ' + data);
    const newItem = {
      id: data.code,
      name: data.code,
      price_decimals: data.price_dec,
      qty_decimals: data.qty_dec,
    };

    if (data.i_type < MAX_TRADABLE_INSTRUMENT_TYPE) {
      setCodeOptions(codeOptions => [...codeOptions, newItem ]);
    };

  }, [setCodeOptions]); 

  useEffect(() => {
    const handleEvent = (e) => {
      const { type, data } = e.detail;
      if (type === ADD_INSTRUMENT) {
        AddInstrumentDropDownItem(data);
      }
      else if (type === ADD_TRADING_ACCOUNT) {
        AddTradingAccountDropDownItem(data);
      }
      else if (type === INSTRUMENT_SELECTED) {
        setCode(data);
        setPriceField('');
        setQtyField('');
      }
      else if (type === CLEAR_TABLE_DATA) {
        setCodeOptions([]);
        setTradingAccountOptions([]);
      }
    };

    window.addEventListener(ORDERS_FORM, handleEvent);

    return () => {
      window.removeEventListener(ORDERS_FORM, handleEvent);
    };

  }, [AddInstrumentDropDownItem, AddTradingAccountDropDownItem, setCode, setCodeOptions, setTradingAccountOptions, setPriceField, setQtyField]);

  const onBuySellClick = (side) => {
    // console.log('onBuySellClick: ' + side);
    setBuySell(side);
  };

  // ========== ADD THE NEW useEffect HOOKS HERE ==========
  // 1. Handle Type dropdown changes
  useEffect(() => {
    if (orderType === MARKET) {
      setIsPriceDisabled(true);
      setPriceField('');
      setDurationType(DURATION_IMMEDIATE);      
      setIsDurationDisabled(true); 
      setSpecialType(DROPDOWN_LIST_NONE_ID);
      setIsSpecialTypeDisabled(true); 
    } else if (orderType === LIMIT) {
      setIsPriceDisabled(false);
      setPriceField('');
      setIsDurationDisabled(false); 
      setDurationType(DURATION_DAY); 
      setIsSpecialTypeDisabled(false); 
    }
  }, [orderType, setTriggerPrice, setPriceField, setDurationType, setSpecialType]);

  // 2. Handle Duration Type dropdown changes
  // useEffect(() => {
  //   if (durationType === DURATION_SESSION) {
  //     setIsSessionDisabled(false);
  //   } else {
  //     setIsSessionDisabled(true);
  //     setSession(DROPDOWN_LIST_NONE);
  //   }
  // }, [durationType, setSession]);

  useEffect(() => {
    if (!scheduleOrder) {
      setSession(DROPDOWN_LIST_NONE_ID);
    }
  }, [scheduleOrder, setSession]);

  // 3. Handle Trigger Order checkbox changes
  // useEffect(() => {
  //   // if (triggerOrder) {
  //   //   setIsTriggerPriceDisabled(false);
  //   //   // Optionally, you don't need to clear values when enabling
  //   // } else {
  //     // setIsTriggerPriceDisabled(true);
  //     console.log('Trigger order disabled, clearing trigger condition and price');
  //     setTriggerCondition(DROPDOWN_LIST_NONE);
  //     setTriggerPrice('');
  //   // }
  // }, [triggerOrder, setTriggerCondition, setTriggerPrice]);

  // 4. Handle special type changes
  useEffect(() => {
    // console.log('specialType = ', specialType);
    if (specialType === HIDDEN) {
      setHidden(true);
      setFOK(false);
      // setIsVisibleQtyDisabled(false);
      // setDurationType(DURATION_DAY); 
      setIsDurationDisabled(false); // Enable duration for HIDDEN
    } else if (specialType === FOK) {
      setFOK(true);
      setHidden(false);
      // setIsVisibleQtyDisabled(true);
      setVisibleQtyField('');
      setDurationType(DURATION_IMMEDIATE);
      setIsDurationDisabled(true); // DISABLE duration when FOK is selected
    } else {
      setHidden(false);
      setFOK(false);
      // setIsVisibleQtyDisabled(true);
      setVisibleQtyField('');
      setIsDurationDisabled(false); // Enable duration for NONE
      // setDurationType(DURATION_DAY); 
    }
  }, [specialType, setDurationType, setFOK, setHidden, setVisibleQtyField]);

  // ========== END OF NEW useEffect HOOKS ==========

  return (
    <>
    <FormProvider >
      <div className="order-form-container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-control" style={{borderColor: TABLE_ROW_BACKGROUND_COLOR, backgroundColor: TABLE_ROW_BACKGROUND_COLOR}}>
            <DropdownComponent 
              labelName={codeDropDownList.labelName} 
              value={code}
              default={codeDropDownList.default} 
              options={codeDropDownList.codeOptions} 
              onSearchChange={onCodeDropDownListChange} 
            />
            <DropdownComponent 
              labelName={tradingAccountDropDownList.labelName} 
              value={tradingAccount}
              default={tradingAccountDropDownList.default} 
              options={tradingAccountDropDownList.tradingAccountOptions} 
              onSearchChange={(e) => setTradingAccount(e.target.value)} 
            />           

            <DropdownComponent 
              labelName={typeDropDownList.labelName} 
              value={orderType}
              default={typeDropDownList.default} 
              options={typeDropDownList.options} 
              onSearchChange={(e) => setOrderType(e.target.value)} 
            />

            <DropdownComponent 
              labelName={specialTypeDropDownList.labelName} 
              value={specialType}
              default={specialTypeDropDownList.default} 
              options={specialTypeDropDownList.options} 
              onSearchChange={(e) => setSpecialType(e.target.value)} 
              disabled={isSpecialTypeDisabled}
            />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <label className="order-label">Price</label>
            <input className="form_input" type="number" step={ price_step} min={ price_step } placeholder='Limit Price' value={price_field} disabled={isPriceDisabled} onChange={(e)=>setPriceField(e.target.value)} name="Price" />
            <label className="order-label">Quantity</label>
            <input className="form_input" type="number" name="Quantity" step={ qty_step} min={ qty_step } placeholder='Quantity' value={ qty_field} onChange={(e)=>setQtyField(e.target.value)} />
            {specialType === HIDDEN && (
              <>
                <label className="order-label">Visible&nbsp;Qty</label>

                <input
                  className="form_input"
                  type="number"
                  placeholder="For Hidden Orders"
                  step={qty_step}
                  min={qty_step}
                  value={visible_qty_field}
                  onChange={(e) => setVisibleQtyField(e.target.value)}
                  name="Visible"
                />
              </>
            )}

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <DropdownComponent 
              labelName={durationTypeDropDownList.labelName} 
              value={durationType}
              default={durationTypeDropDownList.default} 
              options={durationTypeDropDownList.options} 
              onSearchChange={(e) => setDurationType(e.target.value)} 
              disabled={isDurationDisabled} 
            />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'flex-start',  // Changed from 'flex-end' to 'flex-start'
              gap: '40px',
              gridColumn: 1,  // Place in the label column
              alignSelf: 'center',  // Add this - centers the entire div in the grid row
              //margin: 'auto 0'      // Add this as well
              margin: '0 0 8px 0' 
            }}>
              
              <label className="order-label" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                Schedule Order
              </label>
              <input
                  type="checkbox"
                  style={{ transform: 'scale(1)', margin: 0, cursor: 'pointer' }} 
                  checked={scheduleOrder}
                  onChange={(e) => setScheduleOrder(e.target.checked)}
                />
            </div>

            {scheduleOrder && (
              <DropdownComponent 
                labelName={sessionDropDownList.labelName} 
                value={session}
                default={sessionDropDownList.default} 
                options={sessionDropDownList.options} 
                onSearchChange={(e) => setSession(e.target.value)} 
              />
            )}
            
            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'flex-start',  // Changed from 'flex-end' to 'flex-start'
              gap: '40px',
              gridColumn: 1,  // Place in the label column
              alignSelf: 'center',  // Add this - centers the entire div in the grid row
              //margin: 'auto 0'      // Add this as well
              margin: '0 0 8px 0' 
            }}>
              
              <label className="order-label" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                Trigger Order
              </label>
              <input
                  type="checkbox"
                  style={{ transform: 'scale(1)', margin: 0, cursor: 'pointer' }} 
                  checked={triggerOrder}
                  onChange={(e) => setTriggerOrder(e.target.checked)}
                />
            </div>

            {triggerOrder && (
              <>
                <DropdownComponent 
                  labelName={triggerConditionDropDownList.labelName} 
                  value={triggerCondition}
                  default={triggerConditionDropDownList.default} 
                  options={triggerConditionDropDownList.options} 
                  onSearchChange={(e) => {
                    // Find the selected option by name and set the ID
                    const selectedOption = triggerConditionOptions.find(opt => opt.name === e.target.value);
                    setTriggerCondition(selectedOption?.id || e.target.value);
                  }} 
                />

                <label className="order-label">Trigger&nbsp;Price</label>

                <input
                  className="form_input"
                  type="number"
                  step={price_step}
                  min={price_step}
                  placeholder="Trigger Price"
                  value={triggerPrice}
                  onChange={(e) => setTriggerPrice(e.target.value)}
                  name="TriggerPrice"
                />

                <DropdownComponent 
                  labelName={triggerDurationTypeDropDownList.labelName} 
                  value={triggerDurationType}
                  default={triggerDurationTypeDropDownList.default} 
                  options={triggerDurationTypeDropDownList.options} 
                  onSearchChange={(e) => setTriggerDurationType(e.target.value)} 
                />
              </>
            )}

            <Button className="orderbutton" variant="primary" size="lg" type="submit" onClick={async () => onBuySellClick(BUY_SIDE)}>Buy</Button>
            <Button className="orderbutton" variant="danger" size="lg" type="submit" onClick={() => onBuySellClick(SELL_SIDE)} style={{float: 'right'}} >Sell</Button>
            
          </div>
        </form>
      </div>
    </FormProvider>
    </>
  );
}

